exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.iframe-container[data-v-72916994] {\n  width: 100%;\n  display: flex;\n  overflow: hidden;\n}\n.responsive-iframe[data-v-72916994] {\n  width: 100%;\n  height: auto;\n  border: none;\n  border-radius: 8px;\n}\n@media screen and (max-width: 768px) {\n.responsive-iframe[data-v-72916994] {\n    min-height: 400px;\n}\n}\n", ""]);

// exports
